import VueRouter from 'vue-router';
import store from './store';
import config from '@/config/config';
import routeHelpers from '@satellite/helpers/routes';

// Routes are located in the individual module folders
// Import all of the module routes files.
function loadLocalRoutes() {
  const context = require.context('@/modules', true, /routes.js$/i);
  return context
    .keys()
    .map(context) // import module
    .map(m => m.default); // get `default` export from each resolved module
}

function loadSatelliteRoutes() {
  const context = require.context('@satellite/modules', true, /routes.js$/i);
  return context
    .keys()
    .map(context) // import module
    .map(m => m.default); // get `default` export from each resolved module
}

const moduleRoutes = [...loadLocalRoutes(), ...loadSatelliteRoutes()];
let routes = [
  // Moduleless routes can go here
  {
    path: '/',
    name: 'home',
    meta: {
      requiresAuth: false
    }
  }
];

routes = routeHelpers.registerRoutes(routes, moduleRoutes);

const router = new VueRouter({
  mode: 'history',
  routes: routes
});

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

router.beforeEach(async (to, from, next) => {
  // Check if the from route is dirty (has unsaved data), if it is then ask user if they want to proceed
  if (await routeHelpers.checkDirty(store, from)) {
    return;
  }

  const authRequired = routeHelpers.isAuthRequired(to);

  routeHelpers.setPageTitle(store, to, config.application_name);

  if (!authRequired) {
    routeHelpers.setAppLoadedTrue(store);
    next();
    return;
  }

  if (await routeHelpers.isUserAuthorized(store, false)) {
    routeHelpers.setAppLoadedTrue(store);
    next();
  } else {
    routeHelpers.setAppLoadedTrue(store);
    next({ name: 'notAuthorized' });
  }
});

export default router;
